/* eslint-disable jsx-a11y/alt-text */
import { Box, Divider, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { RootStyle } from './style';

interface IProps {
  index: number;
}

export function NoticePage({ index }: IProps) {
  return (
    <Stack mr={8} mb={4}>
      <Stack direction='row' mb={2}>
        <Typography variant='h6' flex={1}>
          {index + 1} 페이지
        </Typography>
        <Stack direction='row'>
          <img src='/images/icons/icChevronDown.svg' />
          <img src='/images/icons/icChevronUp.svg' />
          <img src='/images/icons/icClose.svg' />
        </Stack>
      </Stack>
      <Stack direction='row' mb={4}>
        <Stack
          justifyContent='center'
          alignItems='center'
          height={300}
          width={375}
          style={{ backgroundColor: '#F8F9FA' }}
        >
          <Box justifyContent='center' alignItems='center'>
            <Typography>이미지 업로드</Typography>
            <Typography>750x600px</Typography>
            <Typography>png,Jpeg, gif, webp</Typography>
          </Box>
        </Stack>
        <Stack ml={2} flex={1} spacing={1}>
          <TextField
            id='outlined-required'
            defaultValue=''
            placeholder='제목을 입력해주세요'
            onChange={(e) => {
              console.log(e.target.value);
            }}
            fullWidth
          />
          <TextField
            id='outlined-required'
            defaultValue=''
            placeholder='내용을 입력해주세요'
            onChange={(e) => {
              console.log(e.target.value);
            }}
            fullWidth
            multiline
            rows={7}
          />
        </Stack>
      </Stack>
      <Divider />
    </Stack>
  );
}
